var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("wv-steak-house-default-section", {
    staticClass: "menu--section-two_column",
    attrs: { section: _vm.section, menu: _vm.menu },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }